import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../../components/ui/sheet";
import { useCart } from "../../context/CartContext";
import { inr } from "../../lib/api";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";

export default function CartDrawer() {
  const { items, open, setOpen, update, remove, subtotal } = useCart();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="p-6 border-b border-stone-200">
          <SheetTitle className="font-serif-display text-2xl">Your bag</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-auto p-6 space-y-4" data-testid="cart-drawer">
          {items.length === 0 && (
            <div className="h-full flex flex-col items-center justify-center text-stone-500 py-12">
              <ShoppingBag className="w-10 h-10 mb-3"/>Your bag is empty.
            </div>
          )}
          {items.map(i => (
            <div key={`${i.product_id}-${i.variant_sku}`} className="flex gap-3" data-testid={`cart-item-${i.variant_sku}`}>
              <img src={i.image} alt="" className="w-20 h-20 rounded-lg object-cover"/>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm truncate">{i.product_name}</div>
                <div className="text-xs text-stone-500">{i.variant_label} · {inr(i.unit_price)}</div>
                <div className="flex items-center gap-2 mt-2">
                  <button onClick={()=>update(i.variant_sku, i.product_id, i.qty-1)} className="border border-stone-200 rounded-full p-1"><Minus className="w-3 h-3"/></button>
                  <span className="text-sm font-outfit min-w-[1.5rem] text-center">{i.qty}</span>
                  <button onClick={()=>update(i.variant_sku, i.product_id, i.qty+1)} className="border border-stone-200 rounded-full p-1"><Plus className="w-3 h-3"/></button>
                  <button onClick={()=>remove(i.variant_sku, i.product_id)} className="ml-auto text-stone-400 hover:text-red-600"><Trash2 className="w-4 h-4"/></button>
                </div>
              </div>
              <div className="text-sm font-outfit font-semibold">{inr(i.unit_price*i.qty)}</div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="p-6 border-t border-stone-200 space-y-3">
            <div className="flex justify-between text-sm"><span className="text-stone-500">Subtotal</span><span className="font-outfit font-semibold">{inr(subtotal)}</span></div>
            <div className="text-xs text-stone-500">Shipping & taxes calculated at checkout.</div>
            <Link to="/checkout" onClick={()=>setOpen(false)} data-testid="cart-checkout"
                  className="block text-center bg-[#3B2F2F] text-white rounded-full py-3 font-medium hover:bg-black">
              Checkout — {inr(subtotal)}
            </Link>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
